// import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'

//TODO:全局开关

axios.defaults.baseURL = process.env.ENV_BASEAPIURL;
axios.defaults.timeout = 5000;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.validateStatus = function (status) {

  return status >= 200 && status <= 500 // 默认的
}

axios.interceptors.request.use(config => {

  //TODO:全局开关
  config.headers['saas_userInfo'] = Cookies.get(process.env.ENV_COOKIE_NAME);

  //ie 缓存处理
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }
  return config

}, error => {

  return Promise.reject(error)

});

// HTTPresponse拦截
axios.interceptors.response.use(res => {
  const status = Number(res.status) || 200

  // 不存在cookie  code
  if (status !== 200) {
    return Promise.reject(res.status)
  }

  // 时间戳记录
  try {
    if (res.data.timestamp) {
      Cookies.set('timestamp', res.data.timestamp)
    }
  } catch (error) { }

  return res
}, error => {
  return Promise.reject(error)
})


export default axios

